import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { BannerItem, BannerListOrderResponse, BannerListRequest, CryptoPayload, DataStatus, UpdateBannerOrderRequest } from 'src/common/interfaces/Banner.interface';
import { lastValueFrom } from 'rxjs';
import { decrypt, encrypt } from '../utils/constants';

@Injectable({
  providedIn: 'root'
})
export class CarruselService {
  APIURL: any = environment.ENDPOINTS;

  constructor(private http: HttpClient) { }

  sendReport(data: any) {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.APIURL.BANNERS}/link/reporte`, data).subscribe(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  validateEmpleados(data: any) {
    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    let params = { headers: headers };
    return new Promise((resolve,reject)=>{
      this.http.post(`${this.APIURL.VALIDAR_USUARIOS}/employee-validation-name`,data,params).subscribe(
        res => resolve(res),
        error => {
          console.log(error)
          reject(error)
        }
      );
    });
  }

  validateEmpleadosOld(data: any){
    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    let params = { headers: headers };
    return new Promise((resolve,reject)=>{
      this.http.post(`${this.APIURL.VALIDATION_OLD}/getValidation`,data,params).subscribe(
        res => resolve(res),
        error => {
          console.log(error)
          reject(error)
        }
      );
    });
  }

  getBanners(data: any) {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.APIURL.BANNERS}/link/banners`, data).subscribe(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  createBanner(data: any) {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.APIURL.BANNERS}/link/banner`, data).subscribe(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  deleteBanner(idBanner: number, idUser: any){
    return new Promise((resolve, reject) => {
      this.http.delete(`${this.APIURL.BANNERS}/link/banner/${idBanner}/user/${idUser}`)
        .subscribe( res => {
          resolve(res);
        },
      (err) => {
        reject(err);
      });
    });
  }

  getEditData(data: any){
    return new Promise((resolve, reject) => {
      this.http.post(`${this.APIURL.BANNERS}/link/banner/consulta`, data).subscribe(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  updateBanner(data: any, idBanner: number, idUser: number){
    return new Promise((resolve, reject) => {
      this.http.put(`${this.APIURL.BANNERS}/link/banner/${idBanner}`, data).subscribe(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getModules(data: any) {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.APIURL.MODULES}/dynamic-link/getLinks`, data).subscribe(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getCatalogo(data: any) {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.APIURL.BANNERS}/link/tipo/catalogo`, data).subscribe(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getJobs(data: any) {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.APIURL.JOBS}/getJobs`, data).subscribe((response) => {
        resolve(response);
      }, (err) => {
        console.log(err);
        reject(err)
      })
    })
  }

  getNewJobs(idBanner?: number){
    return new Promise((resolve, reject) => {
      
      const params = idBanner != null
      ? new HttpParams().set('idBanner', idBanner.toString())
      : {};

      this.http.get(`${this.APIURL.NEWJOBS}`, {params}).subscribe((response) => {
        resolve(response)
      }, err => {
        console.log(err)
        reject(err)
      })
    })
  }

  async getBannersOrderList(request: BannerListRequest): Promise<BannerItem[]> {
    try {
      const encrypted = { data: request };
      const encoded = await encrypt(encrypted) as CryptoPayload;
      
      const encryptedRes = await lastValueFrom(
        this.http.post<CryptoPayload>(`${this.APIURL.BANNERS}/link/main`, { data: encoded.data })
      );      
      
      const decoded = await decrypt({ data: encryptedRes.data }) as BannerListOrderResponse;
      
      if (decoded.data.code !== 200 || !decoded.data.items?.[0]?.banners) {
        throw new Error('La respuesta del servidor no es válida o el código no es 200');
      }
      
      return decoded.data.items[0].banners;
    } 
    catch (err) {
      console.error('Error:', err);
      throw err;
    }
  }

  async changeOrderBanners(request: UpdateBannerOrderRequest): Promise<DataStatus> {
    try {
      const encrypted = { data: request };
      const encoded = await encrypt(encrypted) as CryptoPayload;
      
      const encryptedRes = await lastValueFrom(
        this.http.post<CryptoPayload>(`${this.APIURL.BANNERS}/link/ordenamiento`, { data: encoded.data })
      );      
      
      const decoded = await decrypt({ data: encryptedRes.data }) as BannerListOrderResponse;
      
      if (decoded.data.code !== 200) {
        throw new Error('La respuesta del servidor no es válida o el código no es 200');
      }
      
      return decoded.data;
    } 
    catch (err) {
      console.error('Error:', err);
      throw err;
    }
  }

  getNewEmployees(idBanner?: number) {
    return new Promise((resolve, reject) => {
      const params = idBanner != null
        ? new HttpParams().set('idBanner', idBanner.toString())
        : {};

      this.http.get(`${this.APIURL.NEWEMPLOYEES}`, { params }).subscribe(
        (response) => resolve(response),
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

}
